exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".video-container[data-v-35724b88]{position:relative;padding-bottom:56.25%;padding-top:30px;height:0;overflow:hidden}.video-container embed[data-v-35724b88],.video-container iframe[data-v-35724b88],.video-container object[data-v-35724b88]{position:absolute;top:0;left:0;width:100%;height:100%}", ""]);

// exports
